import * as React from "react";

export const MailOutlineIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={9}
    fill="none"
    {...props}
  >
    <path
      fill="#757575"
      d="M.998 0v9h13V0h-13Zm2.157 1h8.687L7.498 3.89 3.155 1Zm-1.157.438 5.219 3.484.281.172.282-.172 5.218-3.484V8h-11V1.437Z"
    />
  </svg>
);
